import { styled } from "@mui/material";
import { Loader } from "@/components/Loader/Loader";

const StyledContainer = styled("div")({
  width: "800px",
  height: "100%",
  maxWidth: "100%",
  margin: "0 auto",
});

export type Props = {
  children: React.ReactNode;
  isLoading?: boolean;
  loaderUrl?: string;
};

export const Container: React.FC<Props> = ({ children, isLoading = false, loaderUrl }) => {
  return <StyledContainer>{isLoading ? <Loader url={loaderUrl} /> : children}</StyledContainer>;
};
